import React from 'react';
import { Divider, Flex, Heading, Text } from '@chakra-ui/react';

interface Props {
    showBreakdown?: boolean;
    discounts?: string;
    discountsSubtitle?: string;
    salesTax?: string;
    salesTaxSubtitle?: string;
    subtotal?: string;
    subtotalSubtitle?: string;
    tipAmount?: string;
    tipAmountSubtitle?: string;
    title: string;
    totalPrice: string;
    totalSubtitle: string;
}

const ClientPaymentSummary = ({
    showBreakdown,
    discounts,
    discountsSubtitle,
    salesTax,
    salesTaxSubtitle,
    subtotal,
    subtotalSubtitle,
    tipAmount,
    tipAmountSubtitle,
    title,
    totalPrice,
    totalSubtitle
}: Props) => {
    return (
        <Flex
            background="gray.25"
            flex={{ base: '0 1 auto', lg: '0 0 350px' }}
            flexDirection="column"
            padding="32px 24px"
        >
            <Heading as="h3" size="lg" margin={0}>
                {title}
            </Heading>
            <Divider borderColor="gray.300" margin="24px 0" />
            {showBreakdown && (
                <>
                    <Flex justifyContent="space-between">
                        <Text textTransform="uppercase">{subtotalSubtitle}</Text>
                        <Text aria-label={subtotalSubtitle}>{subtotal}</Text>
                    </Flex>
                    {discounts && discountsSubtitle && (
                        <Flex justifyContent="space-between">
                            <Text textTransform="uppercase">{discountsSubtitle}</Text>
                            <Text aria-label={discountsSubtitle}>-{discounts}</Text>
                        </Flex>
                    )}
                    {salesTax && salesTaxSubtitle && (
                        <Flex justifyContent="space-between">
                            <Text textTransform="uppercase">{salesTaxSubtitle}</Text>
                            <Text aria-label={salesTaxSubtitle}>{salesTax}</Text>
                        </Flex>
                    )}
                </>
            )}
            {tipAmount && tipAmountSubtitle && (
                <Flex justifyContent="space-between">
                    <Text textTransform="uppercase">{tipAmountSubtitle}</Text>
                    <Text aria-label={tipAmountSubtitle}>{tipAmount}</Text>
                </Flex>
            )}

            {((tipAmount && tipAmountSubtitle) || showBreakdown) && (
                <Divider borderColor="gray.300" margin="24px 0" />
            )}

            <Flex color="brand.primary" justifyContent="space-between">
                <Heading as="h3" size="lg" margin={0} textTransform="uppercase">
                    {totalSubtitle}
                </Heading>
                <Heading as="h3" size="lg" margin={0} aria-label={totalSubtitle}>
                    {totalPrice}
                </Heading>
            </Flex>
        </Flex>
    );
};

export default ClientPaymentSummary;
